// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__ziZns","a":"Button_a__DYa2O","b":"Button_b__65+n2"};